import AbstractComponent from './AbstractComponent';
import { Smoother } from 'core/smooth';
import EmitterManager from '../managers/EmitterManager';
import { SCROLL_TOGGLE } from 'core/Events';

class Menu extends AbstractComponent {
  constructor() {
    super(...arguments);
  }

  initializeBeforeEvents() {
    this.isOpen = false;

    this.scale = Smoother.add({
      precision: 4,
      default: 0,
      smooth: 0.1,
      max: 1,
      min: 0,
    });

    this.handleUpdate(this.scale.value);
  }

  bind() {
    super.bind();
    this.handleUpdate = this.handleUpdate.bind(this);
  }

  getUI() {
    const ui = super.getUI();
    ui.$content = ui.$element.querySelector('.menu__content');
    return ui;
  }

  events(listen) {
    super.events(listen);
    const method = listen ? 'on' : 'removeListener';
    this.scale[method]('update', this.handleUpdate);
  }

  handleUpdate(value) {
    this.ui.$element.style.transform = `scaleY(${value})`;
    this.ui.$content.style.transform = `scaleY(${1 / value})`;
  }

  toggle() {
    this.isOpen = !this.isOpen;
    this.scale.target = this.isOpen ? 1 : 0;
    EmitterManager.emit(SCROLL_TOGGLE, this.isOpen);
  }

  get isOpen() {
    return this._isOpen;
  }

  set isOpen(value) {
    if (value) {
      document.body.classList.add('is-menu-open');
    } else {
      document.body.classList.remove('is-menu-open');
    }

    this._isOpen = value;
  }
}

export default Menu;
